import { jsxs as s, Fragment as u, jsx as i } from "react/jsx-runtime";
import a from "react";
import { u as l } from "./index-6a632112.mjs";
import { AspectRatio as c } from "./aspectRatio.js";
import { r as f } from "./themes-5f0b3c3d.mjs";
import { C as n } from "./ChildrenCountCheck-60cafda6.mjs";
const x = l.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: row;
  gap: 24px;
`, h = l.div`
  width: ${(e) => `${e.size}%`};
  min-width: 25%;
  display: flex;
  flex-direction: column;
  gap: inherit;
`, y = l(c)`
  border-radius: ${f["2x"]};
  overflow: hidden;
  gap: inherit;
  height: 100%;
`, b = ({ children: e }) => /* @__PURE__ */ i(y, { ratio: "16:9", objectFit: "fill", children: e }), P = {
  25: 2,
  33: 2,
  50: 1,
  66: 1,
  100: 1
}, m = ({
  children: e,
  size: r
}) => {
  const p = r.reduce((o, t) => o + t, 0) <= 100, d = a.Children.map(e, (o, t) => (n({
    children: o?.props?.children,
    maxChildren: P[r[t]],
    componentName: "PhotoGalleryThumbnail.Wrapper",
    additionalInfo: "Please remove the extra PhotoGalleryThumbnail.Item children from inside the PhotoGalleryThumbnail.Wrapper"
  }), a.isValidElement(o) && o.type === h ? a.cloneElement(o, { size: r[t] }) : "invalid element"));
  return /* @__PURE__ */ s(u, { children: [
    /* @__PURE__ */ i(
      n,
      {
        children: e,
        maxChildren: r.length,
        componentName: "PhotoGalleryThumbnail",
        additionalInfo: "Please remove the extra PhotoGalleryThumbnail.Wrapper children from inside the PhotoGalleryThumbnail"
      }
    ),
    /* @__PURE__ */ i(x, { children: p ? d : "Unsupported ratio, please use a supported ratio whose sum does not exceed 100. Examples: [25,50,25] or [33,66]" })
  ] });
};
m.Wrapper = h;
m.Item = b;
export {
  m as PhotoGalleryThumbnail
};
